import React, { ReactNode } from 'react';
import styles from './TwoPanelLayout.module.scss';

export const TwoPanelLayout: React.FC<{
    leftPanel: ReactNode;
    contents: ReactNode;
}> = props => {
    return (
        <div className={styles.twoPanelLayout}>
            <div>{props.leftPanel}</div>
            <div className={styles.contentsPanel}>
                {props.contents}
                {props.children}
            </div>
        </div>
    );
};
